<template lang='pug'>
  .fpui-package-editor
    fpui-tabs(ref='steps', :footer='false')
      fpui-tab(:header="'fpStore.package.editor.general' | translate")
        fpui-package-editor-general(@input='$emit("input", $event)', v-bind='{ isNew, item: value, errors }')
      fpui-tab(:header="'fpStore.package.editor.versions' | translate")
        fpui-package-editor-versions(@input='$emit("input", $event)', v-bind='{ isNew, item: value, errors }')
      fpui-tab(:header="'fpStore.package.editor.translation' | translate")
        fpui-package-editor-translation(@input='$emit("input", $event)', v-bind='{ isNew, item: value, errors }')
</template>

<script>
import _get from 'lodash/get'
import _kebabCase from 'lodash/kebabCase'
import FpuiPackageEditorGeneral from './FpuiPackageEditorGeneral'
import FpuiPackageEditorTranslation from './FpuiPackageEditorTranslation'
import FpuiPackageEditorVersions from './FpuiPackageEditorVersions'

export default {
  components: {
    FpuiPackageEditorGeneral,
    FpuiPackageEditorTranslation,
    FpuiPackageEditorVersions
  },
  props: {
    isNew: { type: Boolean, default: false },
    value: { type: Object, required: true },
    title: { type: String },
    loading: { type: Boolean, default: false },
    errors: { type: Object },
    consumer: { type: String, default: '' }
  },
  created () {
    let item = {...this.value}
    if (typeof item.private === 'undefined') {
      item.private = false
    }
    item.preview = item.preview || []
    if (item.versions) {
      item.versions = item.versions.map(version => ({
        name: version,
        source: true,
        existed: true,
        remove: false
      }))
    } else {
      item.versions = []
    }
    item.name = item.name || ''
    item.consumer = item.consumer || this.consumer
    item.i18n = item.i18n || {}
    item.i18n.fr = item.i18n.fr || {}
    item.i18n.en = item.i18n.en || {}
    item.i18n.jp = item.i18n.jp || {}
    item.i18n.fr.name = _get(item.i18n, 'fr.name') || this.$i18n.translateIn('fr', `${item.consumer}.${_kebabCase(item.name.toLowerCase())}.name`, item.name)
    item.i18n.en.name = _get(item.i18n, 'en.name') || this.$i18n.translateIn('en', `${item.consumer}.${_kebabCase(item.name.toLowerCase())}.name`, item.name)
    item.i18n.jp.name = _get(item.i18n, 'jp.name') || this.$i18n.translateIn('jp', `${item.consumer}.${_kebabCase(item.name.toLowerCase())}.name`, item.name)
    item.i18n.fr.description = _get(item.i18n, 'fr.description') || this.$i18n.translateIn('fr', `${item.consumer}.${_kebabCase(item.name.toLowerCase())}.description`, '')
    item.i18n.en.description = _get(item.i18n, 'en.description') || this.$i18n.translateIn('en', `${item.consumer}.${_kebabCase(item.name.toLowerCase())}.description`, '')
    item.i18n.jp.description = _get(item.i18n, 'jp.description') || this.$i18n.translateIn('jp', `${item.consumer}.${_kebabCase(item.name.toLowerCase())}.description`, '')
    item.i18n.fr.long_description = _get(item.i18n, 'fr.long_description') || this.$i18n.translateIn('fr', `${item.consumer}.${_kebabCase(item.name.toLowerCase())}.long_description`, '')
    item.i18n.en.long_description = _get(item.i18n, 'en.long_description') || this.$i18n.translateIn('en', `${item.consumer}.${_kebabCase(item.name.toLowerCase())}.long_description`, '')
    item.i18n.jp.long_description = _get(item.i18n, 'jp.long_description') || this.$i18n.translateIn('jp', `${item.consumer}.${_kebabCase(item.name.toLowerCase())}.long_description`, '')
    this.$emit('input', item)
  },
  data () {
    return {
      actions: [{name: 'check', class: 'fpui fpui-check'}]
    }
  }
}
</script>

<style lang='less'>
  .fpui-package-editor {
    .fpui-helper {
      display: inline-block;
      margin-left: 10px;
      font-size: 12px;
    }
    label {
      line-height: 35px;
    }
    .btn.fpui-button.add-version {
      padding-right: 0;
    }
  }
</style>
